import { render, staticRenderFns } from "./EmployeeCaseloadEditor.vue?vue&type=template&id=7b3c874a&scoped=true&"
import script from "./EmployeeCaseloadEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeCaseloadEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCaseloadEditor.vue?vue&type=style&index=0&id=7b3c874a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c874a",
  null
  
)

export default component.exports